import { render } from "./uni_checkBox.vue?vue&type=template&id=072d22ac"
import script from "./uni_checkBox.vue?vue&type=script&lang=js"
export * from "./uni_checkBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__